module.exports = __webpack_public_path__ + "images/ico-device-act.svg?ff2f147707f356aae625b2aaad59371a";